import React, { useEffect, useState } from 'react';
import { ChatMessageData, ConsentControllerChatMessageData } from '../types';
import { parseChatMessage } from '../MessageInterperter';

type ConsentWidgetData = {
  text?: string;
  approveText?: string;
  denyText?: string;
};

const getConsentFromMessages = (chatMessages: ChatMessageData[]) => {
  const consent = chatMessages.find(
    (message) => message.role === 'consentController',
  );
  return consent;
};

export enum CONSENT_STATUS {
  APPROVED = 'approved',
  DENIED = 'denied',
  NOT_SELECTED = 'not_selected',
}

export const useConsent = (chatMessages: ChatMessageData[]) => {
  const [showConsent, setShowConsent] = useState(false);
  const [consentStatus, setConsentStatus] = React.useState(
    CONSENT_STATUS.NOT_SELECTED,
  );
  const [consentMessage, setConsentMessage] = useState<
    ChatMessageData | undefined
  >(getConsentFromMessages(chatMessages));

  useEffect(() => {
    if (chatMessages.length < 2) {
      setShowConsent(false);
      setConsentMessage(undefined);
      return;
    }

    const receivedConsentMessage = getConsentFromMessages(chatMessages);
    if (receivedConsentMessage) {
      setShowConsent(true);
      setConsentMessage(receivedConsentMessage);
      return;
    }

    const consentWasAnswered = !!consentMessage;
    if (consentWasAnswered) {
      setTimeout(() => {
        setShowConsent(false);
        setConsentMessage(undefined);
        setConsentStatus(CONSENT_STATUS.NOT_SELECTED);
      }, 3000);
    }
  }, [consentMessage, chatMessages]);

  let consentData: ConsentWidgetData | undefined;
  if (consentMessage) {
    const parsed = parseChatMessage(consentMessage.content || '', [
      {
        widgetName: 'CONSENT_CONTROLLER',
        component: () => <></>,
      },
    ]);
    consentData = parsed[0]?.data;
  }

  return {
    showConsent,
    consentData,
    consentMessage: consentMessage as ConsentControllerChatMessageData,
    setConsentStatus,
    consentStatus,
  };
};
